export default __webpack_public_path__ + "static/media/EE-Communication _ Signal Processing.d1c755e6.pdf";